import { render, staticRenderFns } from "./SubjectQueryModal.vue?vue&type=template&id=5482c741&scoped=true&"
import script from "./SubjectQueryModal.vue?vue&type=script&lang=js&"
export * from "./SubjectQueryModal.vue?vue&type=script&lang=js&"
import style0 from "./SubjectQueryModal.vue?vue&type=style&index=0&id=5482c741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482c741",
  null
  
)

export default component.exports